import React, { useState, useEffect } from "react";
import { AlertItem } from "./AlertItem";
import { AlertItem as AlertItemType } from "./types";

interface AlertsListProps {
  activeFilter?: string;
}

export const AlertsList: React.FC<AlertsListProps> = ({ activeFilter = "all" }) => {
  const [alerts, setAlerts] = useState<AlertItemType[]>([
    {
      id: "1",
      icon: "https://cdn.builder.io/api/v1/image/assets/e8fd2a11e5e6412dbddb276a310a5dca/6789bd3c77808a06b23bb48372a0702294ab25fe?placeholderIfAbsent=true",
      title: "Potential Leak Detected",
      description:
        "Unusual continuous flow detected in your system. Please check for any running taps or leaks.",
    },
    {
      id: "2",
      icon: "https://cdn.builder.io/api/v1/image/assets/e8fd2a11e5e6412dbddb276a310a5dca/da7469de089dc4b7ab44bd42acc750c54ea89f0a?placeholderIfAbsent=true",
      title: "High Usage Alert",
      description:
        "Your water usage is 40% higher than your usual consumption for this time of day.",
    },
    {
      id: "3",
      icon: "https://cdn.builder.io/api/v1/image/assets/e8fd2a11e5e6412dbddb276a310a5dca/01c5f3989727abc5c0d11ff14bd71b5b8f35f4f8?placeholderIfAbsent=true",
      title: "Weekly Goal Achieved!",
      description:
        "Congratulations! You've met your weekly water saving goal of 15% reduction.",
    },
    {
      id: "4",
      icon: "https://cdn.builder.io/api/v1/image/assets/e8fd2a11e5e6412dbddb276a310a5dca/cec797511849684c7dd7d9ef209d76fe9d7de662?placeholderIfAbsent=true",
      title: "Municipal Notice",
      description:
        "Scheduled maintenance work in your area on July 15. Water supply may be affected between 10 AM - 2 PM.",
    },
  ]);

  // Function to dismiss an alert
  const dismissAlert = (id: string) => {
    setAlerts(alerts.filter(alert => alert.id !== id));
  };

  // Filter alerts based on the active filter
  const filteredAlerts = alerts.filter(alert => {
    if (activeFilter === "all") return true;
    if (activeFilter === "unread") return !alert.read;
    if (activeFilter === "leaks") return alert.title.toLowerCase().includes("leak");
    if (activeFilter === "highUsage") return alert.title.toLowerCase().includes("high usage");
    return true;
  });

  return (
    <section className="w-full">
      <header className="w-full text-lg font-semibold leading-loose text-gray-900">
        <div className="w-full">
          <h2 className="w-full">{activeFilter === "all" ? "All Alerts" : 
            activeFilter === "unread" ? "Unread Alerts" :
            activeFilter === "leaks" ? "Leak Alerts" : "High Usage Alerts"}</h2>
        </div>
        <div className="flex mt-5 w-full bg-gray-200 min-h-px" />
      </header>

      <div className="mt-6 w-full">
        <div className="w-full">
          <div className="w-full">
            <div className="w-full">
              {filteredAlerts.length > 0 ? filteredAlerts.map((alert, index) => (
                <div key={alert.id} className={index > 0 ? "mt-3" : ""}>
                  <AlertItem
                    icon={alert.icon}
                    title={alert.title}
                    description={alert.description}
                    onDismiss={() => dismissAlert(alert.id)}
                    read={alert.read}
                  />
                </div>
              )) : (
                <div className="py-4 text-center text-gray-500">
                  No alerts in this category
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
